<template>
  <el-row>
    <el-col>
      <el-card
        v-loading="isLoading"
        shadow="never"
      >
        <CarrierDetail
          ref="carrierDetail"
          :form-data="formData.detailData"
        />
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import CarrierDetail from '@/components/Application/Manage/Carriers/Carrier/Detail'
export default {
  components: {
    CarrierDetail
  },
  data () {
    return {
      title: 'Detail',
      breadcrumb: {
        name: 'Detail',
        route: { name: 'manage-carriers-carrier-configurations-detail' }
      },
      actions: [
        {
          name: 'Save',
          icon: ['fal', 'save'],
          event: this.save
        }
      ],
      isSaving: false,
      isLoading: false,
      carrier: [],
      formData: {
        detailData: {
          enabled: false,
          name: null,
          fullName: null,
          phone: null,
          address: null,
          suburb: null,
          state: null,
          postcode: null,
          carrier_group: null,
          carrier_tier: null
        }
      }
    }
  },
  mounted () {
    this.loadCarrierById()
  },
  methods: {
    loadCarrierById () {
      this.isLoading = true
      this.$sdk.carrier.read(this.$route.params.carrierId, (builder) => {
        builder.include = ['carrier_group']
      }).then(res => {
        this.carrier = res
        this.formData.detailData.address = res.address
        this.formData.detailData.fullName = res.full_name
        this.formData.detailData.name = res.name
        this.formData.detailData.phone = res.phone
        this.formData.detailData.postcode = res.postcode
        this.formData.detailData.state = res.state
        this.formData.detailData.suburb = res.town
        this.formData.detailData.enabled = res.enabled
        this.formData.detailData.carrier_group = res.carrier_group
        this.formData.detailData.carrier_tier = res.carrier_tier
        this.isLoading = false
      })
    },
    save () {
      this.carrier.address = this.formData.detailData.address
      this.carrier.full_name = this.formData.detailData.fullName
      this.carrier.name = this.formData.detailData.name
      this.carrier.phone = this.formData.detailData.phone
      this.carrier.postcode = this.formData.detailData.postcode
      this.carrier.state = this.formData.detailData.state
      this.carrier.town = this.formData.detailData.suburb
      this.carrier.enabled = this.formData.detailData.enabled
      this.carrier.carrier_group = this.formData.detailData.carrier_group
      this.carrier.carrier_tier = this.formData.detailData.carrier_tier

      this.$refs.carrierDetail.$refs.form.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.carrier.update()
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
            })
        }
      })
    }
  }
}
</script>
